__turbopack_context__.v({
  "checkbox": "Checkbox-module__NxU7Ha__checkbox",
});
